export default __webpack_public_path__ + "a4a641f7f024148e20e7b44517a47408.png";